import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMerge = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 27,
	height: 27,
	viewBox: "0 0 24 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16.3896 9.814C13.9343 10.383 11.5866 11.321 9.43373 12.5769C5.93783 10.3573 3.03141 7.22539 1.08868 3.42706C0.822126 2.90421 1.03742 2.25834 1.57564 2.01742L4.73835 0.577029C5.23045 0.351487 5.8148 0.551399 6.06598 1.02811C8.25988 5.23139 11.9967 8.3531 16.3896 9.814Z",
		fill: "#2C2A25"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.73831 26.4221L1.57047 24.9817C1.03737 24.7357 0.816955 24.0949 1.0835 23.5721C4.92797 16.0626 12.5554 11.1519 20.9825 10.7623C21.5719 10.7367 22.064 11.2031 22.064 11.7875V15.268C22.064 15.8114 21.6437 16.2573 21.1004 16.2881C14.7493 16.6264 9.0031 20.3273 6.06081 25.971C5.80963 26.4529 5.22527 26.6476 4.73318 26.4221H4.73831Z",
		fill: "#2C2A25"
	})]
});
export default SvgMerge;
